import React from "react";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const QuickStatsCard = ({ data, currentYear, showCardData }) => {
    const yearlyTotals = data?.reduce(
        (acc, item) => {
            acc.billed += parseFloat(item.total_billed || 0);
            acc.paid += parseFloat(item.total_paid || 0);
            acc.due += parseFloat(item.total_due || 0);
            return acc;
        },
        { billed: 0, paid: 0, due: 0 }
    );

    const { billed, paid, due } = yearlyTotals;
    const paymentRate = billed ? ((paid / billed) * 100).toFixed(1) : 0;
    const outstandingRate = billed ? ((due / billed) * 100).toFixed(1) : 0;

    const totalMembers = showCardData?.totalMembers?.total || 0;
    const activeMembers = showCardData?.totalMembers?.active || 0;
    const activeMemberRate = totalMembers ? ((activeMembers / totalMembers) * 100).toFixed(1) : 0;
    
    return (
        <div className="bg-white rounded-xl p-6 w-full h-100 shadow-sm">
            <h2 className="text-xl font-bold text-gray-800 mb-1">
                Quick Stats {currentYear}
            </h2>
            <p className="text-sm text-gray-500 mb-6">Monthly billing overview</p>

            {/* Payment Rate */}
            <div className="mb-4">
                <div className="flex justify-between items-center text-sm font-medium text-gray-700 mb-1">
                    <span>Payment Rate</span>
                    <span className="text-gray-800 font-semibold">{paymentRate}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div
                        className="bg-green-500 h-2.5 rounded-full"
                        style={{ width: `${paymentRate}%` }}
                    ></div>
                </div>
            </div>

            {/* Outstanding Ratio */}
            <div className="mb-4">
                <div className="flex justify-between items-center text-sm font-medium text-gray-700 mb-1">
                    <span>Outstanding Rate</span>
                    <span className="text-gray-800 font-semibold">{outstandingRate}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div
                        className="bg-red-400 h-2.5 rounded-full"
                        style={{ width: `${outstandingRate}%` }}
                    ></div>
                </div>
            </div>
            <div className="mb-4">
                <div className="flex justify-between items-center text-sm font-medium text-gray-700 mb-1">
                    <span>Active Members</span>
                    <span className="text-gray-800 font-semibold">{activeMemberRate}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div
                        className="bg-blue-500 h-2.5 rounded-full"
                        style={{ width: `${activeMemberRate}%` }}
                    ></div>
                </div>
            </div>
            <hr className="my-4" />
            <div className="grid grid-cols-3 gap-3 text-sm text-gray-700 mt-4">
                <div className="bg-white rounded-xl shadow-md text-center">
                    <p className="text-gray-500 text-sm">Total Members</p>
                    <p className="text-xl font-bold text-blue-600">{totalMembers || 0}</p>
                </div>
                <div className="bg-white rounded-xl shadow-md text-center">
                    <p className="text-gray-500 text-sm">Active Members</p>
                    <p className="text-xl font-bold text-green-600">{activeMembers || 0}</p>
                </div>
                <div className="bg-white rounded-xl shadow-md text-center">
                    <p className="text-gray-500 text-sm">Inactive Members</p>
                    <p className="text-xl font-bold text-slate-600">{showCardData?.totalMembers?.inactive || 0}</p>
                </div>
                <div className="bg-white rounded-xl shadow-md text-center">
                    <p className="text-gray-500 text-sm">Total Billed</p>
                    <p className="text-xl font-bold text-yellow-500">${billed || 0}</p>
                </div>
                <div className="bg-white rounded-xl shadow-md text-center">
                    <p className="text-gray-500 text-sm">Total Paid</p>
                    <p className="text-xl font-bold text-emerald-600">${paid || 0}</p>
                </div>
                <div className="bg-white rounded-xl shadow-md text-center">
                    <p className="text-gray-500 text-sm">Total Due</p>
                    <p className="text-xl font-bold text-rose-500">${due || 0}</p>
                </div>
            </div>


        </div>
    );
};

export default QuickStatsCard;
